(function () {
  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function enhanceSelect(nativeSelect) {
    if (!nativeSelect || nativeSelect.dataset.vhEnhanced === 'true') return;

    var wrap = nativeSelect.closest('.vh-delivery-checker__select-wrap');
    if (!wrap) return;

    var root = document.createElement('div');
    root.className = 'vh-delivery-country-select';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'vh-delivery-country-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerText = document.createElement('span');
    triggerText.className = 'vh-delivery-country-select__trigger-text';

    var triggerIcon = document.createElement('span');
    triggerIcon.className = 'vh-delivery-country-select__trigger-icon';
    triggerIcon.setAttribute('aria-hidden', 'true');
    triggerIcon.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="M7 9.5 12 14.5 17 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    trigger.appendChild(triggerText);
    trigger.appendChild(triggerIcon);

    var panel = document.createElement('div');
    panel.className = 'vh-delivery-country-select__panel';

    var searchWrap = document.createElement('div');
    searchWrap.className = 'vh-delivery-country-select__search-wrap';

    var searchIcon = document.createElement('span');
    searchIcon.className = 'vh-delivery-country-select__search-icon';
    searchIcon.setAttribute('aria-hidden', 'true');
    searchIcon.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="6.5" stroke="currentColor" stroke-width="1.5"/><path d="m16 16 4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    var search = document.createElement('input');
    search.type = 'search';
    search.className = 'vh-delivery-country-select__search';
    search.placeholder = 'Szukaj kraju…';
    search.autocomplete = 'off';
    search.setAttribute('aria-label', 'Szukaj kraju');

    searchWrap.appendChild(searchIcon);
    searchWrap.appendChild(search);

    var list = document.createElement('div');
    list.className = 'vh-delivery-country-select__list';
    list.setAttribute('role', 'listbox');

    var empty = document.createElement('div');
    empty.className = 'vh-delivery-country-select__empty';
    empty.textContent = 'Nie znaleziono kraju.';

    panel.appendChild(searchWrap);
    panel.appendChild(list);
    panel.appendChild(empty);
    root.appendChild(trigger);
    root.appendChild(panel);
    wrap.appendChild(root);

    var placeholder = nativeSelect.options[0] ? nativeSelect.options[0].textContent.trim() : 'Wybierz kraj';
    var optionButtons = [];

    Array.prototype.slice.call(nativeSelect.options).forEach(function (option, index) {
      if (index === 0 && option.value === '') return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vh-delivery-country-select__option';
      button.setAttribute('role', 'option');
      button.dataset.value = option.value;
      button.dataset.search = normalizeText(option.textContent);

      var label = document.createElement('span');
      label.textContent = option.textContent.trim();

      var check = document.createElement('span');
      check.className = 'vh-delivery-country-select__check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';

      button.appendChild(label);
      button.appendChild(check);
      list.appendChild(button);
      optionButtons.push(button);

      button.addEventListener('click', function () {
        nativeSelect.value = button.dataset.value;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncSelected();
        closePanel();
        trigger.focus();
      });
    });

    function syncSelected() {
      var selected = nativeSelect.options[nativeSelect.selectedIndex];
      triggerText.textContent = selected && nativeSelect.value !== '' ? selected.textContent.trim() : placeholder;

      optionButtons.forEach(function (button) {
        var selectedState = button.dataset.value === nativeSelect.value && nativeSelect.value !== '';
        button.classList.toggle('is-selected', selectedState);
        button.setAttribute('aria-selected', selectedState ? 'true' : 'false');
      });
    }

    function filterOptions() {
      var query = normalizeText(search.value);
      var visible = 0;

      optionButtons.forEach(function (button) {
        var match = !query || button.dataset.search.indexOf(query) !== -1;
        button.hidden = !match;
        if (match) visible += 1;
      });

      empty.classList.toggle('is-visible', visible === 0);
    }

    function openPanel() {
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      search.value = '';
      filterOptions();
      window.setTimeout(function () { search.focus(); }, 20);
    }

    function closePanel() {
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function () {
      if (root.classList.contains('is-open')) closePanel();
      else openPanel();
    });

    search.addEventListener('input', filterOptions);

    search.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        var firstVisible = optionButtons.find(function (button) { return !button.hidden; });
        if (firstVisible) firstVisible.focus();
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        closePanel();
        trigger.focus();
      }
    });

    list.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePanel();
        trigger.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closePanel();
    });

    nativeSelect.addEventListener('change', syncSelected);

    nativeSelect.dataset.vhEnhanced = 'true';
    wrap.classList.add('vh-delivery-select-enhanced');
    syncSelected();
  }

  function init(scope) {
    (scope || document).querySelectorAll('.vh-delivery-checker .vh-delivery-checker__select').forEach(enhanceSelect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
